import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useRef, createElement, Fragment, cloneElement } from 'react';
import cn from 'classnames';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { usePopoverState, PopoverDisclosure, Popover as Popover$1, PopoverArrow } from 'reakit/Popover';

var _excluded = ["children", "disclosure", "disclosureTooltip", "placement", "visible"];
var Popover = function Popover(props) {
  var children = props.children,
      disclosure = props.disclosure,
      disclosureTooltip = props.disclosureTooltip,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$visible = props.visible,
      visible = _props$visible === void 0 ? false : _props$visible,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var defaultRef = useRef(typeof document !== 'undefined' ? document.body : null);
  var popover = usePopoverState({
    placement: placement,
    visible: visible
  });
  var className = cn('yt-popover', props.className);
  return createElement(Fragment, null, disclosure && createElement(PopoverDisclosure, Object.assign({}, popover, disclosure.props), function (disclosureProps) {
    var button = cloneElement(disclosure, disclosureProps);
    return disclosureTooltip ? createElement(Tooltip, {
      title: disclosureTooltip
    }, button) : button;
  }), popover.visible && createElement(Popover$1, Object.assign({}, popover, {
    hideOnClickOutside: true,
    modal: true
  }, otherProps, {
    className: className,
    unstable_finalFocusRef: disclosure ? undefined : defaultRef
  }), createElement(PopoverArrow, Object.assign({}, popover, {
    className: "yt-popover__arrow"
  })), typeof children === 'function' ? children({
    hide: popover.hide
  }) : children));
};

export { Popover };
//# sourceMappingURL=Popover.js.map
